// extracted by mini-css-extract-plugin
export default {"button":"SelectionButton_button__gcPtc"};